import React from 'react'
import { clearLocalStorage } from '../../../utils/utils.js'
import Header from './Header.js'
import { reactToCwp } from '../../../../../common/react-utils.jsx'

const HeaderApp = props => {
  const { rigSetupUrl } = props.content

  const handleToolReset = () => {
    clearLocalStorage()
    localStorage.setItem('clientName', '')
    window.location.replace(rigSetupUrl)
    return null
  }
  return (
    <div>
      <Header handleToolReset={handleToolReset} />
    </div>
  )
}
export default reactToCwp(HeaderApp)
